import React from 'react';
import { Box, Typography } from '@mui/material';
import { livingRoomSectionStyles } from './LivingRoomSection.styles';
import LivingRoomImage from '../../../../assets/about/LivingRoom.jpg';

const LivingRoomSection = () => {
  const styles = livingRoomSectionStyles();

  return (
    <Box sx={styles.container}>
      <Box
        sx={styles.backgroundImage}
        style={{ backgroundImage: `url(${LivingRoomImage})` }}
      />
      <Box sx={styles.colorOverlay} />
      <Box sx={styles.marqueeContainer}>
        <Box sx={styles.marqueeContent}>
          <Typography sx={styles.marqueeText}>
            Refined Living • Thoughtfully Curated •
          </Typography>
          <Typography sx={styles.marqueeText}>
            Refined Living • Thoughtfully Curated •
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default LivingRoomSection;

